import { useState } from 'react';
import './photoModal.css';
import { normalizeImageUrl } from '../../utils/utils';

interface PhotoModalProps {
  photos: Array<{
    id: string;
    photoUrl: string;
  }>;
  isOpen: boolean;
  onClose: () => void;
  initialPhotoIndex: number;
  carNumber: string;
}

function PhotoModal({ photos, isOpen, onClose, initialPhotoIndex, carNumber }: PhotoModalProps) {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(initialPhotoIndex);

  if (!isOpen) return null;

  const handlePrevPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev > 0 ? prev - 1 : photos.length - 1));
  };

  const handleNextPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev < photos.length - 1 ? prev + 1 : 0));
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const currentPhoto = photos[currentPhotoIndex];

  return (
    <div className="photo-modal-overlay" onClick={handleOverlayClick}>
      {/* Кнопка закрытия */}
      <button className="autopark-modal-close" onClick={onClose}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_162_26)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.0003 13.414L17.6573 19.071C17.8459 19.2532 18.0985 19.354 18.3607 19.3517C18.6229 19.3494 18.8737 19.2443 19.0591 19.0588C19.2445 18.8734 19.3497 18.6226 19.352 18.3604C19.3543 18.0982 19.2535 17.8456 19.0713 17.657L13.4143 12L19.0713 6.34303C19.2535 6.15443 19.3543 5.90182 19.352 5.63963C19.3497 5.37743 19.2445 5.12662 19.0591 4.94121C18.8737 4.7558 18.6229 4.65063 18.3607 4.64835C18.0985 4.64607 17.8459 4.74687 17.6573 4.92903L12.0003 10.586L6.34331 4.92903C6.15386 4.75137 5.90272 4.65439 5.64304 4.65861C5.38336 4.66283 5.1355 4.76791 4.95192 4.95162C4.76834 5.13533 4.66343 5.38326 4.6594 5.64295C4.65537 5.90263 4.75252 6.1537 4.93031 6.34303L10.5863 12L4.92931 17.657C4.8338 17.7493 4.75762 17.8596 4.70521 17.9816C4.6528 18.1036 4.62522 18.2348 4.62406 18.3676C4.62291 18.5004 4.64821 18.6321 4.69849 18.755C4.74877 18.8779 4.82302 18.9895 4.91692 19.0834C5.01081 19.1773 5.12246 19.2516 5.24536 19.3018C5.36825 19.3521 5.49993 19.3774 5.63271 19.3763C5.76549 19.3751 5.89671 19.3475 6.01872 19.2951C6.14072 19.2427 6.25106 19.1665 6.34331 19.071L12.0003 13.414Z"
              fill="#3563E9"
            />
          </g>
          <defs>
            <clipPath id="clip0_162_26">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <div className="photo-modal">
        {/* Основной контент */}
        <div className="photo-modal__content">
          {/* Изображение */}
          <div className="photo-modal__image-container">
            {currentPhoto?.photoUrl ? (
              <img
                src={normalizeImageUrl(currentPhoto.photoUrl)}
                alt={`Фото кузова автомобиля ${carNumber}`}
                className="photo-modal__image"
              />
            ) : (
              <div className="photo-modal__placeholder">
                <svg width="222" height="193" viewBox="0 0 222 193" fill="none">
                  <g id="Group 2">
                    <path
                      d="M83.9574 24.0752C85.633 21.1728 89.8222 21.1728 91.4978 24.0752L159.932 142.606C161.607 145.508 159.513 149.136 156.161 149.136H19.2937C15.9424 149.136 13.8478 145.508 15.5235 142.606L83.9574 24.0752Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M137.625 55.04C139.301 52.1377 143.49 52.1377 145.165 55.04L196.617 144.156C198.292 147.059 196.198 150.687 192.847 150.687H89.9439C86.5926 150.687 84.498 147.059 86.1736 144.156L137.625 55.04Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <circle cx="198.677" cy="23.222" fill="white" fillOpacity="0.3" r="23.222" />
                  </g>
                </svg>
              </div>
            )}
          </div>

          {/* Навигационные стрелки */}
          {photos.length > 1 && (
            <div className="photo-modal__navigation">
              <button className="photo-modal__nav-btn photo-modal__nav-btn--prev" onClick={handlePrevPhoto}>
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                  <path
                    d="M18.5 12L14.5 16L18.5 20"
                    stroke="#1D61E7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    opacity="0.5"
                    d="M3.16602 16C3.16602 9.71457 3.16602 6.57187 5.11864 4.61925C7.07126 2.66663 10.214 2.66663 16.4993 2.66663C22.7847 2.66663 25.9274 2.66663 27.8801 4.61925C29.8327 6.57187 29.8327 9.71457 29.8327 16C29.8327 22.2854 29.8327 25.428 27.8801 27.3807C25.9274 29.3333 22.7847 29.3333 16.4993 29.3333C10.214 29.3333 7.07126 29.3333 5.11864 27.3807C3.16602 25.428 3.16602 22.2854 3.16602 16Z"
                    stroke="#1D61E7"
                    stroke-width="1.5"
                  />
                </svg>
              </button>
              <button className="photo-modal__nav-btn photo-modal__nav-btn--next" onClick={handleNextPhoto}>
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                  <path
                    d="M14.5 12L18.5 16L14.5 20"
                    stroke="#1D61E7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    opacity="0.5"
                    d="M3.16602 16C3.16602 9.71457 3.16602 6.57187 5.11864 4.61925C7.07126 2.66663 10.214 2.66663 16.4993 2.66663C22.7847 2.66663 25.9274 2.66663 27.8801 4.61925C29.8327 6.57187 29.8327 9.71457 29.8327 16C29.8327 22.2854 29.8327 25.428 27.8801 27.3807C25.9274 29.3333 22.7847 29.3333 16.4993 29.3333C10.214 29.3333 7.07126 29.3333 5.11864 27.3807C3.16602 25.428 3.16602 22.2854 3.16602 16Z"
                    stroke="#1D61E7"
                    stroke-width="1.5"
                  />
                </svg>
              </button>
            </div>
          )}

          {/* Подпись */}
          {/* <div className="photo-modal__caption">Фото  автомобиля "{carNumber}"</div> */}
        </div>
      </div>
    </div>
  );
}

export default PhotoModal;
